import { Box, Paper, TextField, Typography } from "@mui/material";
import { createChatBotMessage } from "react-chatbot-kit";
import "./style.css";

const botName = "ScaleUp Bot";

const config = {
  botName: botName,
  lang: "en",
  customStyles: {
    botMessageBox: {
      backgroundColor: "black !important", // Override with MUI color
      borderRadius: "12px", // Rounded corners
      padding: "10px",
      color: "#000", // Override text color
      fontFamily: "'Roboto', sans-serif",
      fontSize: "16px", // MUI Typography equivalent size
    },
    chatButton: {
      backgroundColor: "transparent", // Override with custom color
      borderRadius: "50%",
      width: "3.1875rem !important",
      height: "3.1875rem !important",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      transition: "0.3s ease",
    },
  },
  initialMessages: [
    createChatBotMessage(
      `Hi there! 👋 Welcome to Rebirth Wellness.
I’m here to help you answer any question you have about skincare. How can I support your wellness today? 🌿`,
      {
        withAvatar: true,
        delay: 500,
        widget: "overview",
      }
    ),
  ],
  state: {
    gist: "",
  },
  customComponents: {
    botAvatar: () => (
      <Box
        sx={{
          height: "1.796rem !important",
          width: "1.796rem !important",
          borderRadius: "50%",
          backgroundColor: "info.main",
          padding: "2px",
        }}
      >
        <img
          src="/images/chat-bot-avatar.webp"
          alt="Bot Avatar"
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </Box>
    ),
    userAvatar: () => (
      <Box
        sx={{
          height: "1.796rem !important",
          width: "1.796rem !important",
          borderRadius: "50%",
          backgroundColor: "info.main",
          padding: "2px",
        }}
      >
        <img
          className="userChatbotAvatar"
          src="/images/secureLogin.png" // Replace with the actual path
          alt="User Avatar"
          style={{ width: "100%", height: "100%", borderRadius: "50%" }}
        />
      </Box>
    ),
    // Custom header styled with MUI
    header: () => (
      <Paper
        elevation={3}
        sx={{
          backgroundColor: "info.main",
          color: "white",
          padding: "16px",
          borderRadius: "2.5625rem 2.5625rem 0 0",
          textAlign: "center",
        }}
      >
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{
            color: "white !important",
            fontWeight: "700 !important",
          }}
        >
          LIVE CHAT
        </Typography>
      </Paper>
    ),
    // Custom text input styled using MUI
    textInput: (props) => (
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Type a message..."
        InputProps={{
          style: {
            borderRadius: "20px",
            backgroundColor: "#f0f0f0",
            padding: "10px",
          },
        }}
        {...props}
      />
    ),
    // Bot messages styled with MUI Typography
    botMessage: (props) => (
      <Box
        sx={{
          backgroundColor: "#827F7E",
          color: "#black",
          borderRadius: "15px",
          padding: "10px",
          marginBottom: "10px",
          maxWidth: "70%",
        }}
      >
        <Typography variant="body1" fontWeight="500">
          {props.message}
        </Typography>
      </Box>
    ),
  },
  widgets: [],
};

export default config;
